import React from 'react'
import { Col, Row } from 'reactstrap'

const Mark_Fav_Automatically_COmponent = () => {
  return (
    <>
    <Row style={{marginTop:'15px'}}>
        <Col md={3}>
           <p>Frequency</p>
            <select 
                className="form-select mb-3" 
                aria-label="frequency"           
            >
                <option selected value="5_mins" >5 mins</option>
                <option value="15_mins">15 mins</option>
                <option value="30_mins">30 mins</option>
                <option value="hourly">Hourly</option>
                <option value="daily">Daily</option>
            </select>
        </Col>
        <Col md={3}>
        <p>Condition</p>
        <select 
                className="form-select mb-3" 
                aria-label="condition"           
            >
                
                <option selected value="no_Record" >No Record</option>
                <option value="have_Record">Have Record</option>
                <option value="always">Always</option>
            </select>
        </Col>
        <Col md={3}>
        <p>Type</p>
        <select 
                className="form-select mb-3" 
                aria-label="type"           
            >
                <option selected value="email" >Email</option>
                <option value="whatsApp">WhatsApp</option>
            </select>
        </Col>
        <Col md={3}>
        <p>Source</p>
            <select 
                class="form-select mb-3" 
                aria-label="source"           
            >
                <option selected value="SQL" >SQL</option>
                <option value="prompt">Prompt</option>
            </select>
        </Col>
        <Col md={12}>
        <p>Subject</p>
           <textarea className="form-control" aria-label="With textarea" rows="3"></textarea>
        </Col>
    
                    
    </Row>
    </>
  )
}

export default Mark_Fav_Automatically_COmponent